import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import timelineService from "../../services/Timeline/timeline";

interface intialState {
  loading: boolean;
  error: null | string;
  data: any;
  timelineObject: any;
  moveInDate: any;
  miloCurrent: any;
  miloScheduled: any;
  miloCompleted: any;
  reloEvents: any;
  signalUpdate: any;
}

export const initialState: intialState = {
  loading: true,
  error: null,
  data: {},
  timelineObject: {},
  moveInDate: {},
  miloCurrent: {},
  miloScheduled: {},
  miloCompleted: {},
  reloEvents: {},
  signalUpdate: "",
};

export const getTimelineObject = createAsyncThunk(
  "ACTION_GET_TIMELINE_OBJECT",
  async (data: any) => {
    return timelineService.getTimelineObject(data);
  },
);

const getTimelineObjectFulfield = (state: any, action: any) => {
  state.loading = false;
  state.timelineObject.data = action.payload?.data;
};

export const createTimelineObject = createAsyncThunk(
  "ACTION_CREATE_TIMELINE_OBJECT",
  async (data: any) => {
    return timelineService.createTimelineObject(data);
  },
);

const createTimelineObjectFulfield = (state: any, action: any) => {
  state.loading = false;
  state.timelineObject.data = {
    reloEvent: { ...action.payload?.data?.reloEventDetails },
  };
};

export const updateTimelineObject = createAsyncThunk(
  "ACTION_UPDATE_TIMELINE_OBJECT",
  async (data: any) => {
    return timelineService.updateTimelineObject(data);
  },
);

const updateTimelineObjectFulfield = (state: any, action: any) => {
  state.loading = false;
  state.timelineObject.data.reloEvent = action.meta.arg;
};

export const getMoveInDate = createAsyncThunk(
  "ACTION_GET_MOVE_IN_DATE",
  async (data: any) => {
    return timelineService.getMoveInDate(data);
  },
);

const getMoveInDateFulfield = (state: any, action: any) => {
  state.loading = false;
  state.moveInDate.data = action.payload?.data;
};

export const updateMoveInDate = createAsyncThunk(
  "ACTION_UPDATE_MOVE_IN_DATE",
  async (data: any) => {
    return timelineService.updateMoveInDate(data);
  },
);

const updateMoveInDateFulfield = (state: any, action: any) => {
  state.loading = false;
  state.moveInDate.data = action.payload?.data;
};

export const getMiloEventsCurrent = createAsyncThunk(
  "ACTION_GET_MILO_EVENT_CURRENT",
  async (data: any) => {
    return timelineService.getMiloEvents(data);
  },
);

const getMiloEventsCurrentFulfield = (state: any, action: any) => {
  state.miloCurrent.loading = false;
  state.miloCurrent.data = action.payload?.data;
};

const getMiloEventsCurrentPending = (state: any, action: any) => {
  state.miloCurrent.loading = true;
  state.miloCurrent.data = {};
};

const getMiloEventsCurrentRejected = (state: any, action: any) => {
  state.miloCurrent.loading = false;
  state.miloCurrent.data = {};
};

export const getMiloEventsScheduled = createAsyncThunk(
  "ACTION_GET_MILO_EVENT_SCHEDULED",
  async (data: any) => {
    return timelineService.getMiloEvents(data);
  },
);

const getMiloEventsScheduledFulfield = (state: any, action: any) => {
  state.miloScheduled.loading = false;
  state.miloScheduled.data = action.payload?.data;
};

const getMiloEventsScheduledPending = (state: any, action: any) => {
  state.miloScheduled.loading = true;
  state.miloScheduled.data = {};
};

const getMiloEventsScheduledRejected = (state: any, action: any) => {
  state.miloScheduled.loading = false;
  state.miloScheduled.data = {};
};

export const getMiloEventsCompleted = createAsyncThunk(
  "ACTION_GET_MILO_EVENT_COMPLETED",
  async (data: any) => {
    return timelineService.getMiloEvents(data);
  },
);

const getMiloEventsCompletedFulfield = (state: any, action: any) => {
  state.miloCompleted.loading = false;
  state.miloCompleted.data = action.payload?.data;
};

const getMiloEventsCompletedPending = (state: any, action: any) => {
  state.miloCompleted.loading = true;
  state.miloCompleted.data = {};
};

const getMiloEventsCompletedRejected = (state: any, action: any) => {
  state.miloCompleted.loading = false;
  state.miloCompleted.data = {};
};

export const getReloEvents = createAsyncThunk(
  "ACTION_GET_RELO_EVENTS",
  async (id: string) => {
    return timelineService.getReloEvents(id);
  },
);

const getReloEventsFulfield = (state: any, action: any) => {
  state.loading = false;
  state.reloEvents.data = action.payload?.data;
};

const timelineSlice = createSlice({
  name: "timeline",
  initialState,
  reducers: {
    signalUpdate(state, action) {
      state.signalUpdate = action.payload;
    },
    reset: () => initialState,
  },
  extraReducers(builder): void {
    builder.addCase(getTimelineObject.fulfilled, getTimelineObjectFulfield);
    builder.addCase(
      createTimelineObject.fulfilled,
      createTimelineObjectFulfield,
    );
    builder.addCase(
      updateTimelineObject.fulfilled,
      updateTimelineObjectFulfield,
    );
    builder.addCase(getMoveInDate.fulfilled, getMoveInDateFulfield);
    builder.addCase(
      getMiloEventsCurrent.fulfilled,
      getMiloEventsCurrentFulfield,
    );
    builder.addCase(
      getMiloEventsScheduled.fulfilled,
      getMiloEventsScheduledFulfield,
    );
    builder.addCase(
      getMiloEventsCompleted.fulfilled,
      getMiloEventsCompletedFulfield,
    );
    builder.addCase(getReloEvents.fulfilled, getReloEventsFulfield);
    builder.addCase(updateMoveInDate.fulfilled, updateMoveInDateFulfield);

    builder.addCase(getMiloEventsCurrent.pending, getMiloEventsCurrentPending);
    builder.addCase(
      getMiloEventsScheduled.pending,
      getMiloEventsScheduledPending,
    );
    builder.addCase(
      getMiloEventsCompleted.pending,
      getMiloEventsCompletedPending,
    );

    builder.addCase(
      getMiloEventsCurrent.rejected,
      getMiloEventsCurrentRejected,
    );
    builder.addCase(
      getMiloEventsScheduled.rejected,
      getMiloEventsScheduledRejected,
    );
    builder.addCase(
      getMiloEventsCompleted.rejected,
      getMiloEventsCompletedRejected,
    );

    builder.addMatcher(
      (action) =>
        action.type.endsWith("/pending") || action.type.endsWith("/rejected"),
      (state, action) => {
        state.loading = action.meta.requestStatus === "pending";
        state.error = action?.error?.message;
      },
    );
  },
});

export default timelineSlice.reducer;
export const { signalUpdate, reset } = timelineSlice.actions;
